module.exports = __webpack_public_path__ + "img/@logo_dap.e36a41a9.png";